import React from 'react'
import styles from './FeatureBlock.module.css'
import Reveal from '../Reveal/Reveal'

type FeatureBlockProps = {
    number: string
    total: string
    /** 要素ごとに改行して1つの見出しとして表示。1行なら要素1つの配列にする */
    heading: string[]
    /** 要素ごとに段落（<p>）を分けて表示。1段落なら要素1つの配列にする */
    body: string[]
    image: string
    imageAlign?: 'left' | 'right'
    /** ビュー計測用ラベル（data-view-label） */
    analyticsLabel: string
}

/** 番号付きの「働く魅力」ブロック（番号＋見出し＋本文＋写真） */
export default function FeatureBlock({
    number,
    total,
    heading,
    body,
    image,
    imageAlign = 'left',
    analyticsLabel,
}: FeatureBlockProps) {
    const photoClassName = `${styles.photo} ${
        imageAlign === 'right' ? styles.photoAlignRight : styles.photoAlignLeft
    }`
    const headingText = heading.join('')

    return (
        <Reveal className={styles.block} analyticsLabel={analyticsLabel}>
            <p className={styles.number}>
                <span className={styles.numberLine} />
                {number}
                <span className={styles.numberTotal}>{`/${total}`}</span>
            </p>
            <h3 className={styles.heading}>
                {heading.map((line, index) => (
                    <React.Fragment key={index}>
                        {index > 0 && <br />}
                        {line}
                    </React.Fragment>
                ))}
            </h3>
            {body.map((paragraph, index) => (
                <p key={index} className={styles.body}>
                    {paragraph}
                </p>
            ))}
            <img src={image} alt={headingText} className={photoClassName} />
        </Reveal>
    )
}
